import {
  useCartAndDeliveryDatesDataContext,
  useUpdateShippingDetails,
} from '@app/data/clients/cartCheckoutClient';
import { UpdateShippingDetailsAPIRequest } from '@app/types/monolith/types';
import { useCallback } from 'react';
import { mapCartToPayPalRequiredCartFromMonolith } from './utils';

export const usePayPalShippingAddressChangeHandler = () => {
  const { dispatch, client } = useCartAndDeliveryDatesDataContext();

  const { handler: handleUpdateShippingDetails } = useUpdateShippingDetails({
    client,
    dispatch,
  });

  const handleShippingAddressChange = useCallback(
    async (shippingAddress: UpdateShippingDetailsAPIRequest) => {
      const result = await handleUpdateShippingDetails({
        countryCode: shippingAddress?.countryCode || '',
        postcode: shippingAddress?.postcode || '',
        state: shippingAddress?.state || '',
      });

      if (result.state === 'FAILED' || !result?.data) {
        const errorMessage =
          result.errors?.[0]?.exception || 'Failed to update shipping address';
        throw new Error(errorMessage);
      }

      return mapCartToPayPalRequiredCartFromMonolith(result.data);
    },
    [handleUpdateShippingDetails]
  );

  return { handleShippingAddressChange };
};
